<template>
    <div id="app">
        <router-view v-if="isRouterAlive"/>
    </div>

</template>
<script>
    import "./assets/common.less";
    import Mixins from "./utils/Mixins.js";

    export default {
        mixins: [Mixins],
        name: "App",
        provide() {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
            return {
                reload: this.reload
            }
        },
        data() {
            return {
                isRouterAlive: true
            }
        },
        props: {},
        components: {},
        created() {
            if (sessionStorage.getItem('store')) {
                this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))));
            }
            window.addEventListener('beforeunload', () => {
                sessionStorage.setItem('store', JSON.stringify(this.$store.state));
            });
        },
        methods: {
            reload() {
                this.isRouterAlive = false;            //先关闭，
                this.$nextTick(function () {
                    this.isRouterAlive = true;         //再打开
                })
            }
        }
    }

</script>
<style lang="less">

    body {
        margin-right: calc(-1 * (100vw - 100%));
        overflow-x: hidden;
    }


    #app {
        width: 100%;
        min-width: 1024px;
        max-width: 1920px;
        /*min-height: 100%;*/
        /*height: auto;*/
        height: 100%;
        margin: 0 auto;
        background-color: #F0F2F5;
        color: rgba(0, 0, 0, .65);
        font-family: Chinese Quote,
        -apple-system,
        BlinkMacSystemFont,
        Segoe UI,
        PingFang SC,
        Hiragino Sans GB,
        Microsoft YaHei,
        Helvetica Neue,
        Helvetica,
        Arial,
        sans-serif,
        Apple Color Emoji,
        Segoe UI Emoji,
        Segoe UI Symbol;


        /*    重写 btn 样式*/

        .ant-btn-primary {
            background-color: #F0F2F5 !important;
            color: #666 !important;
            border-color: transparent !important;
            box-shadow: 0 1px 0 #767676,0 1px 1px rgba(0,0,0,0.7);
          /*  box-shadow: inset 0 0 0 1px hsl(0deg 0% 0% / 20%),
                        inset 0 1px 0 hsl(0deg 0% 100% / 10%),
                        inset 0 1px 0 hsl(0deg 0% 100% / 10%),
                        inset 0 -1px 0 hsl(0deg 0% 100% / 10%),
                        inset 0 -1px 0 hsl(0deg 0% 0% / 25%),
                        0 1px 1px hsl(0deg 0% 0% / 5%);*/
        }


    }

    /* 公共滚动条 样式*/

    .scrollbar::-webkit-scrollbar { /*滚动条整体样式*/

        width: 10px; /*高宽分别对应横竖滚动条的尺寸*/

        height: 1px;

    }

    .scrollbar::-webkit-scrollbar-thumb { /*滚动条里面小方块*/

        border-radius: 10px;

        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);

        background: rgba(17, 17, 16, 0.11);

    }

    .scrollbar::-webkit-scrollbar-track { /*滚动条里面轨道*/

        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);

        border-radius: 10px;

        background: #EDEDED;

    }

    /* tab 滚动条 样式*/

    .tabScrollbar::-webkit-scrollbar { /*滚动条整体样式*/
        /*position: absolute;*/
        /*right: 0;*/
        width: 0px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;

    }

    .tabScrollbar::-webkit-scrollbar-thumb { /*滚动条里面小方块*/

        border-radius: 10px;

        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);

        background: #6cc4d3;

    }

    .tabScrollbar::-webkit-scrollbar-track { /*滚动条里面轨道*/

        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);

        border-radius: 10px;

        background: #EDEDED;

    }

    /**/
    .siteTable .ant-table-thead > tr > th {
        background-color: #bfd9e1;
    }

    .siteTable .ant-table-thead {
        font-size: 10px;
    }

    .siteTable .ant-table td {
        white-space: nowrap;
    }

    /* 图标*/
    .icon-jiantou {
        top: -40%;
        cursor: pointer;
        height: 20px;
        line-height: 20px;
    }

    .icon-jiantou:before {
        content: "\25B2"
    }

    .icon-jiantouxia {
        top: 30%;
        cursor: pointer;
        height: 20px;
        line-height: 20px;
    }

    .icon-jiantouxia:before {
        content: "\25BC"
    }

    .navBarValue {
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 100%;
        }
    }

    #header {
        .ant-menu-horizontal > .ant-menu-item-active,
        .ant-menu-horizontal > .ant-menu-item-open,
        .ant-menu-horizontal > .ant-menu-item-selected,
        .ant-menu-horizontal > .ant-menu-item:hover,
        .ant-menu-horizontal > .ant-menu-submenu-active,
        .ant-menu-horizontal > .ant-menu-submenu-open,
        .ant-menu-horizontal > .ant-menu-submenu-selected,
        .ant-menu-horizontal > .ant-menu-submenu:hover {
            color: #fff !important;
        }
    }

    /*重写 ant 样式*/

    .ant-btn-primary {
        background-color: #bfd9e1 !important;
        color: #444 !important;
    }

    /*重写 头部菜单 宽度*/
    .ant-menu-vertical.ant-menu-sub, .ant-menu-vertical-left.ant-menu-sub, .ant-menu-vertical-right.ant-menu-sub {
        min-width: 120px !important;
    }

    /*重写 voc 头部样式*/
    #vocHeader .el-menu--horizontal > .el-submenu .el-submenu__title {
        height: 40px;
        line-height: 40px;
    }

    #vocHeader .el-menu--horizontal > .el-menu-item {
        height: 40px;
        line-height: 40px;
    }

    #vocHeader .el-menu.el-menu--horizontal {
        border-bottom: 0;
    }

    #vocHeader .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
        border-bottom: 0;
    }

    .moduleItem {
        .el-button--mini, .el-button--mini.is-round {
            padding: 4px;
        }
    }

    .reportDialog {
        .el-dialog__header {
            border-bottom: 1px solid #ddd;
        }
    }

    .moduleItem {
        .el-button + .el-button {
            margin-left: 4px;
            font-size: 12px;
        }
    }

    .user-state {
        .el-input__inner {
            background-color: transparent;
            color: #fff;
            border: none;
        }
    }

    /*天蓝卫士 头部菜单高度*/
    .headerMenu {
        .el-submenu__title {
            padding: 0 8px;
        }

        .el-menu--horizontal > .el-submenu .el-submenu__title {
            height: 50px;
            line-height: 50px;
        }

        .el-menu--horizontal > .el-menu-item {
            height: 50px;
            line-height: 50px;
        }
    }


    .siteTable {
        label {
            margin-bottom: 0;
        }
    }


    .message-error{
        .el-message__content{
            margin-right: 20px;
            max-height: 500px;
            min-height: 18px;
            overflow: auto !important;
        }
    }


</style>
